import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Formio } from '@formio/js';
import { environment } from './environments/environment';

import premium from '@formio/premium';

Formio.license = environment.LICENSE;
Formio.use(premium);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
